import { useState } from 'react'
import ReactDOM from "react-dom";
import { useSelector } from 'react-redux'
import classes from './AlertsControls.module.css'
import Button from '../../../common/Button'
import Modal from '../../../common/Modal';
import AddAlerts from './AddAlerts';
import Backdrop from '../../../common/modal/Backdrop';

export default function AlertsControls() {
    const activeCase = useSelector(state => state.case.activeCase)

    const [isModalOpened, setisModalOpened] = useState(false)

    const openModalHandler = () => {
        setisModalOpened(true)
    }

    const closeModalHandler = () => {
        setisModalOpened(false)
    }
    return <>
        <div className={classes.controls}>
            {activeCase && <Button click={openModalHandler}>
                <i className="ti ti-square-plus"></i>Add alert
            </Button>}
        </div>

        {isModalOpened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <AddAlerts data={activeCase} closeModal={closeModalHandler} typeSelected={'Attorney'}/>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}